module.exports = __webpack_public_path__ + "static/media/0022_Small.6368ec3f.jpg";